import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RewardService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  createReward(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `rewards`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getRewards(): Observable<any> {
    return this.http.get(this.base_url + 'rewards').pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  getRewardTypes(): Observable<any> {
    return this.http.get(this.base_url + 'rewards/types').pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  // deleteApiKey(data: any): Observable<any> {
  //   return this.http
  //     .delete(this.base_url + `organization/api-key`, { body: data })
  //     .pipe(
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }
}

